import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { map, Observable, take, tap } from 'rxjs';

import { Type } from '../models/custom-sites/custom-sites';
import { CustomSiteService } from '../services/custom-site.service';
import { RouterService } from '../services/router.service';

@Injectable({
  providedIn: 'root'
})
export class CustomSiteExistsGuard implements CanActivate {
  constructor(
    private custom_site_service: CustomSiteService,
    private router_service: RouterService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const type: Type = route.data.type;
    const id: number = route.paramMap.has("id") ? parseInt(route.paramMap.get("id")) : null;

    return this.custom_site_service.get_custom_sites_by_type$(type).pipe(
      take(1),
      map(sites => (type === Type.NEWS && sites.length > 0) || sites.some(s => s.id === id)),
      tap(site_exists => !site_exists && this.router_service.navigate("/not-found"))
    );
  }
}
